module.exports = __webpack_public_path__ + "img/video13.24c81d3c.jpg";